

<div class="container mar">

  <mat-card>
    <mat-card-header>
      <mat-card-title><h2 style="color:darkblue; font-weight:bolder;">About the dataset</h2></mat-card-title>
    </mat-card-header>
    <hr>
    <mat-card-content>
      <p>Heart disease describes a range of conditions that affect your heart. Diseases under the heart disease umbrella include blood vessel diseases, such as coronary artery disease, heart rhythm problems (arrhythmias) and heart defects you’re born with (congenital heart defects), among others.</p>
      <ul>
        <li>About 610,000 people die of heart disease in the United States every year–that’s 1 in every 4 deaths.1</li>
        <li>Heart disease is the leading cause of death for both men and women. More than half of the deaths due to heart disease in 2009 were in men.1</li>
        <li>Every year about 735,000 Americans have a heart attack. Of these, 525,000 are a first heart attack and 210,000 happen in people who have already had a heart attack.</li>
        <li><em><b>The dataset used in this application is the Cleveland Heart Disease dataset taken from the UCI repository.</b></em></li>
      </ul>
    </mat-card-content>
    <hr>
    <mat-card-footer class="cent">
      <a href="https://towardsdatascience.com/heart-disease-prediction-73468d630cfc" class="btn btn-primary m-2" target="_blank">About Dataset</a>
    </mat-card-footer>
  </mat-card>

</div>
